module.exports = __webpack_public_path__ + "img/blueprintgame.84efa9fb.png";